export const generateUniqueID = (): string => {
  const existingID = localStorage.getItem('unique_id');

  if (existingID) return existingID;
  
  const timestamp = Date.now().toString();
  const randomCharacters = Math.random().toString(36).substring(2, 15);
  const uniqueID = timestamp + randomCharacters;

  localStorage.setItem('unique_id', uniqueID);

  return uniqueID;
}